module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/rectangle-2-3792bfdce1bc3a330ded9937097f91df.png";